"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QnAContents = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const Colors_1 = require("../../../../Colors");
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const server_1 = require("../../../../server");
const functions_1 = require("../../../../server/functions");
const account_1 = require("../../../base/account");
const DeletePopUpLayout_1 = require("../../../base/layout/DeletePopUpLayout");
const popup_1 = require("../../../base/popup");
const action_1 = require("../../../menu/action");
const QnAContentsHead_1 = require("./QnAContentsHead");
const qnaContentsStyled_1 = require("./qnaContentsStyled");
exports.QnAContents = react_1.default.memo(({ data, number, totalCount, depths, isQuestion = false, isHistory = false, isCloseAnswer = false, questionData, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const localId = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserId)(state));
    const { root_id, id, author_id, status, type } = (0, react_1.useMemo)(() => data, [data]);
    const isMyAuthor = (0, react_1.useMemo)(() => author_id === localId, [author_id, localId]);
    const [checkImportance, setCheckImportance] = react_1.default.useState(data?.importance);
    const modifyQnaMutation = (0, react_query_1.useMutation)(server_1.modifyQna);
    const deleteQnaMutation = (0, react_query_1.useMutation)(server_1.deleteQna);
    const previousPage = () => {
        dispatch((0, action_1.goToPrevMenu)());
    };
    const renderRequestionBtn = (0, react_1.useMemo)(() => {
        const handlerRequestion = () => {
            dispatch((0, action_1.updateMenu)(undefined, { menu: 'qna', detail: 're_regist' }, data.root_id, {
                isReQuestion: true,
                isTeacher,
                isPopup: false,
                isModify: false,
                depths,
                root_id: data.root_id,
            }));
        };
        return (react_1.default.createElement(common_1.Button, { className: "btn_default xmd", text: "supportRoom.requestion", onClick: () => handlerRequestion() }));
    }, [isTablet, isMobile, data]);
    const renderDelBtn = (0, react_1.useMemo)(() => {
        const handleDelete = (type) => {
            if (isTeacher && type === 'question') {
                APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                    component: DeletePopUpLayout_1.DeletePopUpLayout,
                    componentProps: {
                        deleteContent: t('supportRoom.questionAndAnswerDelete', { count: 1 }),
                        onDelete: async () => {
                            // 전체 질문 삭제
                            try {
                                APP.eventManager.publish('SHOW_LOADING', true);
                                await deleteQnaMutation.mutateAsync(questionData.id);
                                previousPage();
                                APP.eventManager.publish('REFETCH_QNA_LIST');
                            }
                            catch (error) {
                                alert(error);
                            }
                            finally {
                                APP.eventManager.publish('SHOW_LOADING', false);
                            }
                        },
                    },
                    width: 639,
                    title: t(`supportRoom.${type}Delete`),
                    isFit: true,
                });
            }
            else {
                APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                    component: DeletePopUpLayout_1.DeletePopUpLayout,
                    componentProps: {
                        deleteContent: t('assignment.delteInto', { count: 1 }),
                        onDelete: async () => {
                            try {
                                APP.eventManager.publish('SHOW_LOADING', true);
                                await deleteQnaMutation.mutateAsync(id);
                                previousPage();
                                APP.eventManager.publish('REFETCH_QNA_LIST');
                            }
                            catch (error) {
                                alert(error);
                            }
                            finally {
                                APP.eventManager.publish('SHOW_LOADING', false);
                            }
                        },
                    },
                    width: 639,
                    title: t(`supportRoom.${type}Delete`),
                    isFit: true,
                });
            }
        };
        return (react_1.default.createElement(common_1.Button, { className: "btn_line_pink xmd", text: "common.delete", onClick: () => handleDelete(type) }));
    }, [type, id, isTablet, questionData, t]);
    const renderModifyBtn = (0, react_1.useMemo)(() => {
        //질문, 답변 수정
        const handleEditPage = async (edit_id) => {
            dispatch((0, action_1.updateMenu)(undefined, { menu: 'qna', detail: !isQuestion ? 'answer_modify' : 'regist' }, isTeacher ? root_id : edit_id, {
                answer_number: Math.max(0, number - 1),
                isReQuestion: root_id !== id,
                depths,
                isModify: true,
                root_id: data.root_id,
            }));
        };
        return (react_1.default.createElement(common_1.Button, { className: "btn_white xmd", text: "common.modify", onClick: () => handleEditPage(id) }));
    }, [id, depths, isTablet, isMobile, isQuestion, number, root_id, status]);
    const renderLock = (0, react_1.useMemo)(() => {
        return react_1.default.createElement(common_1.Icon, { icon: "locked", fill: Colors_1.Colors.light_grey });
    }, []);
    const renderImportanceCheckBox = (0, react_1.useMemo)(() => {
        const handleImportance = async (id, checked) => {
            if (data) {
                (0, server_1.getQnaList)((0, functions_1.objectToQueryString)({ importance: true, root_only: true })).then(async (res) => {
                    try {
                        const { total_count, items } = res.result;
                        const count = checkImportance ? total_count - 1 : total_count + 1;
                        if (count > 5 && !checkImportance) {
                            alert('필독은 5개까지만 선택 가능합니다.');
                            return;
                        }
                        await modifyQnaMutation.mutateAsync({
                            id: data.id,
                            props: {
                                importance: checkImportance ? false : true,
                            },
                        });
                        setCheckImportance(!checkImportance);
                    }
                    catch (error) {
                        alert(error);
                    }
                    finally {
                        // 간혹 필독 해제시, 리스트가 갱신되지 않는 경우가 있어서 setTimeout 추가
                        setTimeout(() => APP.eventManager.publish('REFETCH_QNA_LIST'), 500);
                    }
                });
            }
        };
        return (react_1.default.createElement(common_1.CheckBoxElement, { id: "importance", title: "\uD544\uB3C5", checked: checkImportance, handlerCheck: handleImportance, className: "must-read", iconSize: 18 }));
    }, [checkImportance, data?.id]);
    const getButtonVisibility = (0, react_1.useCallback)((type) => {
        const isLastQuestion = number + 2 === totalCount;
        if (isTeacher) {
            if (type === 'requestion')
                return false;
            if (isQuestion) {
                if (type === 'modify')
                    return false;
                return isLastQuestion;
            }
            else {
                return isLastQuestion;
            }
        }
        else {
            if (type === 'requestion')
                return isMyAuthor && isQuestion && isCloseAnswer && isLastQuestion;
            if (isQuestion) {
                return !isCloseAnswer && isMyAuthor;
            }
            else {
                return false;
            }
        }
    }, [isTeacher, isQuestion, isCloseAnswer, isMyAuthor, totalCount, number]);
    const showRequestionBtn = (0, react_1.useMemo)(() => getButtonVisibility('requestion'), [getButtonVisibility]);
    const showModifyBtn = (0, react_1.useMemo)(() => getButtonVisibility('modify'), [getButtonVisibility]);
    const showDelBtn = (0, react_1.useMemo)(() => getButtonVisibility('delete'), [getButtonVisibility]);
    return (react_1.default.createElement(qnaContentsStyled_1.QnAContentsStyled, { className: "question-contents", "$isTablet": isTablet, "$isMobile": isMobile, "$isTeacher": isTeacher, "$isHistory": isHistory, "$isQuestion": isQuestion },
        isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(QnAContentsHead_1.QnAContentsHead, { data: data, isQuestion: isQuestion, isTeacher: isTeacher },
                react_1.default.createElement("div", { className: "test" }, isQuestion && data.private && renderLock)),
            react_1.default.createElement("div", { className: "content ql-editor", dangerouslySetInnerHTML: { __html: data.content } }))) : (react_1.default.createElement("div", { className: "content-wrap" },
            react_1.default.createElement(QnAContentsHead_1.QnAContentsHead, { data: data, isQuestion: isQuestion, isTeacher: isTeacher },
                react_1.default.createElement("div", { className: "test" }, isQuestion && data.private && renderLock)),
            react_1.default.createElement("div", { className: "content ql-editor", dangerouslySetInnerHTML: { __html: data.content } }))),
        !isHistory &&
            ((!isQuestion && isTeacher) ||
                showRequestionBtn ||
                showModifyBtn ||
                showDelBtn ||
                data.private) && (react_1.default.createElement("div", { className: "edit-bar2" }, (showRequestionBtn || showModifyBtn || showDelBtn) && (react_1.default.createElement("div", { className: "btn-container2" },
            !isQuestion &&
                isTeacher &&
                !data.private &&
                renderImportanceCheckBox,
            showRequestionBtn && renderRequestionBtn,
            showModifyBtn && renderModifyBtn,
            showDelBtn && renderDelBtn))))));
});
